import React from "react";
import Navbar from "./navbar";
import { Link } from "react-router-dom";
import Footer from "./Footer";

// Import videos from assets
import migration from "../assets/vid1.mp4";
import diani from "../assets/vid2.mp4";
import mountKenya from "../assets/vid3.mp4";
import maasai from "../assets/vid4.mp4";
import tsavo from "../assets/zebras.mp4";
import amboseli from "../assets/rhin.mp4";
import lamu from "../assets/elep.mp4";
import nairobi from "../assets/leaop.mp4";
import buff from "../assets/buffa.mp4"

const videoGallery = [
  { src: migration, title: "Great Migration Adventure" },
  { src: diani, title: "Coastal Paradise - Diani" },
  { src: mountKenya, title: "Mount Kenya Aerial View" },
  { src: maasai, title: "Cultural Maasai Experience" },
  { src: tsavo, title: "Tsavo Wildlife Safari" },
  { src: amboseli, title: "Amboseli Sunset Moments" },
  { src: lamu, title: "Lamu Island Tranquility" },
  { src: nairobi, title: "Nairobi National Park" },
  { src: buff, title: "Nairobi National Park" },
];
const handleMouseEnter = () => {
  // Optional: Add hover effect like changing style or logging
};

const handleMouseLeave = () => {
  // Optional: Reset style or other behavior
};
const GalleryPage = () => {
  const styles = {
    gallery: {
      backgroundColor: "#0d0d0d",
      color: "#fff",
      padding: "4rem 1rem",
      minHeight: "100vh",
    },
    container: {
      maxWidth: "1280px",
      margin: "0 auto",
      textAlign: "center",
    },
    floatingCTA: {
        position: "fixed",
        bottom: "20px",
        right: "20px",
        zIndex: 1000,
      },
      ctaButton: {
        padding: "15px 40px",
        backgroundColor: "#ff6347",
        color: "#fff",
        fontSize: "1.2rem",
        borderRadius: "30px",
        textDecoration: "none",
        fontWeight: "bold",
        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
        transition: "all 0.3s ease",
      },
    heading: {
      fontSize: "2.8rem",
      fontWeight: "bold",
      marginBottom: "0.5rem",
    },
    subheading: {
      fontSize: "1.2rem",
      color: "#aaa",
      marginBottom: "3rem",
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
      gap: "2rem",
    },
    cardWrapper: {
      position: "relative",
      overflow: "hidden",
      borderRadius: "16px",
      height: "0",
      paddingBottom: "56.25%", // 16:9 aspect ratio
      boxShadow: "0 10px 25px rgba(0,0,0,0.5)",
      backgroundColor: "#000",
      transition: "transform 0.3s ease, box-shadow 0.3s ease",
    },
    video: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      objectFit: "cover",
      transition: "transform 0.5s ease-in-out",
    },
    cardHover: {
      transform: "scale(1.02)",
      boxShadow: "0 15px 30px rgba(0,0,0,0.7)",
    },
    videoHover: {
      transform: "scale(1.05)",
    },
    button: {
      backgroundColor: "#ff6f61",
      color: "#fff",
      padding: "15px 30px",
      fontSize: "1.2rem",
      border: "none",
      borderRadius: "8px",
      cursor: "pointer",
      marginTop: "2rem",
      transition: "background-color 0.3s ease",
    },
    buttonHover: {
      backgroundColor: "#e55d50",
    },
  };

  const handleHover = (e, isHovering) => {
    const card = e.currentTarget;
    const video = card.querySelector("video");
    if (isHovering) {
      card.style.transform = styles.cardHover.transform;
      card.style.boxShadow = styles.cardHover.boxShadow;
      video.style.transform = styles.videoHover.transform;
      video.muted = false;
    } else {
      card.style.transform = "scale(1)";
      card.style.boxShadow = styles.cardWrapper.boxShadow;
      video.style.transform = "scale(1)";
      video.muted = true;
    }
  };

  return (
    <>
      <Navbar />
      <div style={styles.floatingCTA}>
  <a
    href="https://mail.google.com/mail/?view=cm&fs=1&to=&su=Booking%20Inquiry&body=Hi,%0D%0A%0D%0AI%20want%20to%20book%20assist%20me"
    style={styles.ctaButton}
    onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave}
    target="_blank"
    rel="noopener noreferrer"
  >
    Book Your Tour
  </a>
</div>
      {/* CSS animation keyframes */}
      <style>
        {`
          @keyframes scrollX {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }

          .scroll-wrapper:hover {
            animation-play-state: paused;
          }
        `}
      </style>

      <section style={styles.gallery}>
        <div style={styles.container}>
          <h2 style={styles.heading}>Explore Our Stunning Video Gallery</h2>
          
          <div style={styles.grid}>
            {videoGallery.map((video, index) => (
              <div
                key={index}
                style={styles.cardWrapper}
                onMouseEnter={(e) => handleHover(e, true)}
                onMouseLeave={(e) => handleHover(e, false)}
              >
                <video
                  src={video.src}
                  autoPlay
                  loop
                  muted
                  playsInline
                  style={styles.video}
                />
              </div>
            ))}
          </div>
         
        </div>
      </section>
      <Footer />
    </>
    
  );
};

export default GalleryPage;
